import axios from "axios";
import { API_URL3 } from "./constants";

const API = axios.create({
  baseURL: `${API_URL3[process.env.NODE_ENV]}`,
  timeout: 10000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("accesstokenhotelparkmall")}`,
  },
  

});

export default API;
